import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectionService, ToastsService } from '@catch/services';
import { Observable } from 'rxjs';
import { catchError, delay, filter, retry, timeout } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly toastsService = inject(ToastsService);
  private readonly router = inject(Router);
  private readonly connectionService = inject(ConnectionService);

  intercept(

    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry({
        count: 4,
        delay: (error) => {
          if (error.status === 0) {
            if (!this.connectionService.connected && request.method !== 'GET') {
              this.toastsService.warning(
                'jobboard.general.no-network-error-message'
              );
            }
            return this.connectionService.connected$.pipe(
              filter((online) => online),
              delay(20),
              timeout({
                each: 10000,
                with: () => {
                  throw error;
                },
              })
            );
          }
          throw error;
        },
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof ErrorEvent) {
          console.log('Error', error.error.message);
        } else {
          if (request.responseType != 'blob' && error.status !== 404) {
            console.log(
              `Error Code: ${error.status}`,
              `Error Message: ${error.message}`
            );
            this.toastsService.handleError(error.error?.message);
          }
          if (request.responseType != 'blob' && error.status === 404) {
            this.router.navigate(['errors', '404']);
          }
        }
        throw error;
      })
    );
  }
}
